<nz-layout>
  <nz-header class="navbar">
    <div class="navbar-container">
      <div class="logo">
        <img src="/app_logo.png" alt="Logo" />
      </div>
      <div class="login-btn-container">
          <button nz-button nzType="default" class="login-btn" (click)="onClientLogin()">
          <nz-icon nzType="user" nzTheme="outline" />
          <span class="login-text">Client Login</span>
        </button>
      </div>

    </div>
  </nz-header>
   <div class="instruction-banner">
    <nz-icon nzType="environment" nzTheme="outline" class="banner-icon"></nz-icon>
    <span class="banner-text">Enter your breakdown location to find nearby service providers instantly</span>
  </div>
  <nz-content>
    <div class="map-wrapper">
      @if (isLoading()) {
        <div class="loading-overlay">
          <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
          <p class="loading-text">Finding nearby service providers...</p>
        </div>
      }
      
      @if (nearbyServiceProviders != null) {      
        <div class="sp-response-popup">
          <div class="popup-header">
            {{ isNoNearbyProviders() ? 'No Nearby Service Providers' : 'GOOD NEWS!' }}
          </div>
          <div class="popup-content">
            @if (getDisplayRanges().length > 0) {
              @for (range of getDisplayRanges(); track range.distance) {
                <p class="service-provider-info">
                  {{range.count}} service provider{{range.count !== 1 ? 's' : ''}} available within {{range.distance}} km
                </p>
              }
            } @else {
              <p class="availability-text">
                No nearby service providers found in our network. Please reach out for help immediately.
              </p>
            }
            <button nz-button class="request-btn" (click)="onRequestHelp()">
              REQUEST HELP NOW
              <div class="no-account-text">- No Account Needed</div>
            </button>
          </div>
        </div>
      }
      @if (incidentLocation?.description != null) {
        <div class="selected-location-popup">
          <div class="popup-header">
            SELECTED LOCATION
          </div>
          <div class="popup-content">
            <h3>{{incidentLocation?.description}}</h3>
          </div>
        </div>
      }
      <app-map-select 
        [mapMarkerLocation]="incidentLocation!"
        (locationSelected)="onLocationSelected($event)"
      ></app-map-select>
      <button nz-button [class]="incidentLocation ? 'proceed-btn' : 'proceed-btn-blue'" (click)="onProceed()" [disabled]="isLoading()">
        Check For Nearby Service Providers
      </button>
 
    </div>

    <div class="trust-section">
      <!-- <h2>Trusted by Fleets Nationwide</h2> -->
      <div class="features">
        <div class="feature">
          <span nz-icon nzType="message" nzTheme="outline" class="feature-icon"></span>
          <h3>WhatsApp Integration</h3>
          <p>Seamlessly integrates with your existing WhatsApp workflows</p>
        </div>
        <div class="feature">
          <span nz-icon nzType="safety-certificate" nzTheme="outline" class="feature-icon"></span>
          <h3>Skilled Nationwide Network</h3>
          <p>Ready to solve your problems, wherever you are</p>
        </div>
        <div class="feature">
          <span nz-icon nzType="file-text" nzTheme="outline" class="feature-icon"></span>
          <h3>Automatic Digital Records</h3>
          <p>Every breakdown professionally documented for complete peace of mind</p>
        </div>
      </div>
    </div>
    
  </nz-content>
  <nz-footer class="footer">
    <div class="footer-content">
      <p class="footer-tagline">Fast, Reliable Roadside Assistance - When You Need It Most</p>
      <p class="footer-text">Join thousands of customers who trust our nationwide network of verified service providers</p>
    </div>
  </nz-footer>
</nz-layout>